var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-10 mb-5 text-center" },
    [
      _c("h1", { staticClass: "m-3 mob-h1-font" }, [
        _vm._v("Welcome to " + _vm._s(_vm.site_name)),
      ]),
      _vm._v(" "),
      _c("h5", { staticClass: "mb-cus-10 mob-h5-font" }, [
        _vm._v("Select your location to start your reservation."),
      ]),
      _vm._v(" "),
      _vm._l(_vm.multi_location_list, function (item, index) {
        return [
          _c(
            "a",
            {
              staticClass: "btn btn-danger m-cus-10",
              staticStyle: { color: "#fff", "min-width": "100px" },
              on: {
                click: function ($event) {
                  return _vm.redirectByLink(item.link, item.name)
                },
              },
            },
            [_vm._v(_vm._s(item.name))]
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }